export class Project {
  constructor() {}

  id: string;
  projectName: string;
  projectImg: string;
  deckHeight: number;
  userId: string;
  snapshots: string[];
  snapshotsProTools: any[];
  projectType: string;
  // dock projects only: Home/Cottage vs Business/Commercial choice
  // (projectType itself stays 'dock' — it is the dock-mode detection key)
  dockSubtype: string;
  accessories: any[];
  deckMaterial: string;
  scenery: string;
  tiers: any[];
  railing: any;
  railingColors: any;
  created: Date;
  updated: Date;
  draw_options: any;
}



// WEBPACK FOOTER //
// ./src/app/classes/project.ts